// auth type actions 

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";






// darkMode type actions 

export const DARK = 'DARK';
export const LIGHT = 'LIGHT';
export const TOGGLE = 'TOGGLE';
//dropdown type actions 

export const DROP_DOWN = "DROP_DOWN"


//mobileSidebarMenu actions
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
